import {
  $getSelection,
  $isParagraphNode,
  $isRangeSelection,
  $isTextNode,
  $insertNodes,
  $createTextNode,
} from "lexical"
import { TOGGLE_LINK_COMMAND, $isLinkNode, $createLinkNode } from "@lexical/link"
import { sanitizeUrl } from "../plugins/LinkPlugin"

export const insertLink = (activeEditor, setIsLinkEditMode, showAlert, Url = "https://") => {
  activeEditor.update(() => {
    const selection = $getSelection()
    const nodes = selection.getNodes()

    const isOnlyParagraphAndText = nodes.every(
      (node) => $isParagraphNode(node) || $isTextNode(node),
    )
    const hasLinkNode = nodes.some((node) => $isLinkNode(node))

    if (hasLinkNode) {
      setIsLinkEditMode(false)
      activeEditor.dispatchCommand(TOGGLE_LINK_COMMAND, null)
      return
    }

    if (!isOnlyParagraphAndText) {
      showAlert("Преобразовать в ссылку несколько строк можно только параграфы", {
        type: "error",
      })
      return
    }

    if (nodes.length === 1) {
      activeEditor.dispatchCommand(TOGGLE_LINK_COMMAND, sanitizeUrl(Url))
    }

    if ($isRangeSelection(selection)) {
      const selectedText = selection.getTextContent()
      const newLinkNode = $createLinkNode(sanitizeUrl(Url))
      const newTextNode = $createTextNode(selectedText)

      selection.removeText()
      newLinkNode.append(newTextNode)
      $insertNodes([newLinkNode])
      setIsLinkEditMode(true)
    }
  })
}
